import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import { SidebarIcon } from './SidebarIcon';
import { RouteItem } from '../../../routes/RouteItem';
import styled from 'styled-components';

const NavItem = styled.div`
  height: 2rem;

  border-left: 2px solid #fff;
  flex-grow: 1;

  &:last-child {
    border-left: none;
  }
`;

const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  width: 100%;
  text-decoration: none;

  .nav-icon {
    font-weight: bold;
    margin-left: -1rem;
    height: 2rem;
    width: 2rem;
    text-align: center;
    line-height: 2rem;
    border-radius: 1rem;
    background: white;
    color: ${props => props.theme.colors.secondaryColor};
  }

  &.-active {
    .nav-icon {
      color: white;
      background: ${props => props.theme.colors.secondaryColor};
    }
  }

  span {
    user-select: none;
    padding-left: 0.5rem;
    color: rgba(255, 255, 255, 0.9);
  }

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }

  &.-disabled {
    cursor: default;
    pointer-events: none;
  }
`;

export const SidebarItem: FunctionComponent<
  Partial<RouteItem> & {
    pathname: string;
    disabled: boolean;
  }
> = props => {
  let className = '';

  if (props.path === props.pathname) className += ' -active';
  if (props.disabled) className += ' -disabled';

  return (
    <NavItem
      id={`sidebar-menu-link-${props.title}`}
      data-testid={`sidebar-menu-link-${props.title}`}
    >
      <NavLink
        to={props.disabled ? props.pathname : props.path!}
        className={className}
      >
        <SidebarIcon icon={props.icon} />
        <span className="-mobile-hide">
          {props.title}
        </span>
      </NavLink>
    </NavItem>
  );
};
